<template>
    <div class="scoreboard">
        <span class="scoreboard__values">
            <span class="scoreboard__value-correct">{{ textValueCorrect() }}</span>
            <span class="scoreboard__value-separator">/</span>
            <span class="scoreboard__value-total">{{ scorelist.length }}</span>
        </span>
        <div
            class="scoreboard__lights"
            :class="numLightClass()">
            <span
                v-for="correctness in scorelist"
                class="scoreboard__light"
                :class="lightCorrectnessClass(correctness)"></span>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            scorelist: {
                type: Array,
                // default: [1],
                // default: [1, 0],
                // default: [1, 2, 3],
                default: [1, 0, 1, 0, 1],
                // default: [-1, -1, -1, -1, -1],
            },
        },

        methods: {
            textValueCorrect(){
                let numCorrect = 0;
                this.scorelist.forEach(correctness => {
                    if(correctness == 1){
                        numCorrect++;
                    }
                });
                return numCorrect;
            },

            numLightClass(){
                if(this.scorelist.length == 1){
                    return 'scoreboard__lights--single';
                }
                return 'scoreboard__lights--multiple';
            },

            lightCorrectnessClass(correctness){
                if(correctness == -1){
                    return 'scoreboard__light--skipped';
                }
                return correctness == 1 ? 'scoreboard__light--correct' : 'scoreboard__light--incorrect'
            }
        }
    };
</script>
<style scoped src="@/css/components/scoreboard-phonetic-transcription.css"></style>